/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ActorMinDTO } from './actor-min-dto';


export interface PraticaCittadinoTimelineItemDTO { 
    event_type?: string;
    stato_da?: PraticaCittadinoTimelineItemDTOStatoDaEnum;
    stato_a?: PraticaCittadinoTimelineItemDTOStatoAEnum;
    timestamp?: string;
    actor?: ActorMinDTO;
    commento?: string;
}
export enum PraticaCittadinoTimelineItemDTOStatoDaEnum {
    IN_ATTESA_OTP = 'IN_ATTESA_OTP',
    RICHIESTA_SOTTOMESSA = 'RICHIESTA_SOTTOMESSA',
    RICHIESTA_IN_LAVORAZIONE = 'RICHIESTA_IN_LAVORAZIONE',
    RICHIESTA_ACCETTATA = 'RICHIESTA_ACCETTATA',
    RICHIESTA_RIFIUTATA = 'RICHIESTA_RIFIUTATA',
    VOUCHER_ASSEGNATI = 'VOUCHER_ASSEGNATI',
    VOUCHER_CONSEGNATI = 'VOUCHER_CONSEGNATI'
};
export enum PraticaCittadinoTimelineItemDTOStatoAEnum {
    IN_ATTESA_OTP = 'IN_ATTESA_OTP',
    RICHIESTA_SOTTOMESSA = 'RICHIESTA_SOTTOMESSA',
    RICHIESTA_IN_LAVORAZIONE = 'RICHIESTA_IN_LAVORAZIONE',
    RICHIESTA_ACCETTATA = 'RICHIESTA_ACCETTATA',
    RICHIESTA_RIFIUTATA = 'RICHIESTA_RIFIUTATA',
    VOUCHER_ASSEGNATI = 'VOUCHER_ASSEGNATI',
    VOUCHER_CONSEGNATI = 'VOUCHER_CONSEGNATI'
};



